import { useLanguage } from '../contexts/LanguageContext';

// Alternative hook name for convenience
export const useTranslation = () => {
  const { t, currentLanguage, changeLanguage } = useLanguage();

  return {
    t,
    i18n: {
      language: currentLanguage,
      changeLanguage
    }
  };
};

export default useTranslation;